import {Table} from "antd";
import {Link} from 'react-router';
import {useRef} from 'react';
import {getColumnSearchProps} from "../widget/SearchProps";

export const BuyerTable = ({buyers, onApiFail, props}) => {
    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'First Name',
            dataIndex: 'firstname',
            key: 'firstname',
            render: (val, buyer, index) => {
                return <Link to={`/buyer/${buyer.id}`}>{val}</Link>
            },
            ...getColumnSearchProps(`firstname`, searchInput)
        },
        {
            title: 'Last Name',
            dataIndex: 'lastname',
            key: 'lastname',
            render: (val, buyer, index) => {
                return <Link to={`/buyer/${buyer.id}`}>{val}</Link>
            },
            ...getColumnSearchProps(`lastname`, searchInput)
        },
        {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            ...getColumnSearchProps(`company`, searchInput)
        },
        {
            title: 'License',
            dataIndex: 'license',
            key: 'license',
            ...getColumnSearchProps(`license`, searchInput)
        }
    ];

    const buyerTable = <Table dataSource={buyers} columns={columns} />;

    return buyerTable
}